import { Injectable, inject } from '@angular/core';

import { SportsProductUtils } from '@frontend/sports/host-app/sports-product/feature/utils';
import { ReplaySubject, combineLatest, map } from 'rxjs';

import { AccaBoostTokenProviderService } from '../../../../lib/acca-boost-base/acca-boost-token-provider.service';
import { CrmOfferLoaderService } from '../../../../lib/crm-offer-data/crm-offer-loader.service';
import { IRewardToken, IRewardTokenData } from '../../../../lib/tokens-base/token-base.models';
import { RewardTokensFactory } from './reward-tokens.factory';

@Injectable({ providedIn: 'root' })
export class RewardTokensDataService {
    private crmOfferLoaderService = inject(CrmOfferLoaderService);
    private rewardTokensFactory = inject(RewardTokensFactory);
    private accaBoostTokenProvider = inject(AccaBoostTokenProviderService);
    private productUtils = inject(SportsProductUtils);

    private readonly tokens$$ = new ReplaySubject<IRewardToken[]>(1);
    readonly tokens$ = this.tokens$$.asObservable();

    init(): void {
        const crmTokens$ = this.crmOfferLoaderService.tokens$.pipe(map(this.mapCrmTokens));
        const accaBoostTokens$ = this.accaBoostTokenProvider.tokens$;

        combineLatest([crmTokens$, accaBoostTokens$])
            .pipe(
                this.productUtils.filterSportsEmitLast(),
                map(([crmTokens, accaBoostTokens]) => {
                    return [...crmTokens, ...accaBoostTokens];
                }),
            )
            .subscribe((tokens) => this.tokens$$.next(tokens));
    }

    refreshCrmOffer(): void {
        this.crmOfferLoaderService.refresh();
    }

    refreshAccaOffer(): void {
        this.accaBoostTokenProvider.refresh();
    }

    private mapCrmTokens = (crmTokensData: IRewardTokenData[]): IRewardToken[] => {
        return this.rewardTokensFactory.toModelList(crmTokensData);
    };
}
